import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    PrestadorHistoricoCorrespondencia,
    PrestadorHistoricoDebito,
    PrestadorHistoricoDebitoSituacao,
    PrestadorHistoricoInscricao,
    PrestadorHistoricoInscricaoRemoverRequest,
    PrestadorHistoricoInscricaoSalvarRequest,
    PrestadorHistoricoOpcao,
    PrestadorHistoricoProtocolo,
    PrestadorHistoricoTramitacao
} from './prestador-historico.model';
import { Observable } from 'rxjs';
import { Page } from '@/shared/models/page.model';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorHistoricoService {
    private readonly http = inject(HttpClient);
    private readonly h = SICOM_PATHS.registro.prestador.historico;

    listarInscricoes(id: number, uf: string, page: number, size: number): Observable<Page<PrestadorHistoricoInscricao>> {
        return this.http.get<Page<PrestadorHistoricoInscricao>>(this.h.inscricoes, { params: { id, uf, page, size } });
    }

    listarTiposInscricao(): Observable<PrestadorHistoricoOpcao[]> {
        return this.http.get<PrestadorHistoricoOpcao[]>(this.h.inscricoesTipos);
    }

    listarSituacoes(idTipoInscricao: number): Observable<PrestadorHistoricoOpcao[]> {
        return this.http.get<PrestadorHistoricoOpcao[]>(this.h.inscricoesSituacoes, {
            params: { idTipoInscricao }
        });
    }

    criarInscricao(request: PrestadorHistoricoInscricaoSalvarRequest): Observable<void> {
        return this.http.post<void>(this.h.inscricoes, request);
    }

    atualizarInscricao(request: PrestadorHistoricoInscricaoSalvarRequest): Observable<void> {
        return this.http.put<void>(this.h.inscricoes, request);
    }

    removerInscricao(request: PrestadorHistoricoInscricaoRemoverRequest): Observable<void> {
        return this.http.delete<void>(this.h.inscricoes, { body: request });
    }

    listarProtocolos(id: number, uf: string, page: number, size: number): Observable<Page<PrestadorHistoricoProtocolo>> {
        return this.http.get<Page<PrestadorHistoricoProtocolo>>(this.h.protocolos, { params: { id, uf, page, size } });
    }

    listarTramitacoes(id: number, uf: string, idProtocolo: number, page: number, size: number): Observable<Page<PrestadorHistoricoTramitacao>> {
        return this.http.get<Page<PrestadorHistoricoTramitacao>>(`${this.h.protocolos}/${idProtocolo}/tramitacoes`, { params: { id, uf, page, size } });
    }

    listarDebitos(id: number, uf: string, situacao: PrestadorHistoricoDebitoSituacao, page: number, size: number): Observable<Page<PrestadorHistoricoDebito>> {
        return this.http.get<Page<PrestadorHistoricoDebito>>(this.h.debitos, { params: { id, uf, situacao, page, size } });
    }

    listarCorrespondencias(id: number, uf: string, page: number, size: number): Observable<Page<PrestadorHistoricoCorrespondencia>> {
        return this.http.get<Page<PrestadorHistoricoCorrespondencia>>(this.h.correspondencias, { params: { id, uf, page, size } });
    }
}
